import { render } from "./devDetails.vue?vue&type=template&id=c07c0824&scoped=true"
import script from "./devDetails.vue?vue&type=script&lang=js"
export * from "./devDetails.vue?vue&type=script&lang=js"

import "./devDetails.vue?vue&type=style&index=0&id=c07c0824&lang=scss&scoped=true"

import exportComponent from "D:\\projects\\gitlab\\DemoLab\\DemoLab-data\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c07c0824"]])

export default __exports__